export enum Gender {
  MALE = 'MALE',
  FEMAle = 'FEMALE',
  OTHERS = 'OTHERS',
  BOTH = 'BOTH'
}
